<template>
	<div class='lpo-result-data'>
		
		<template>
			
			<div class='flex-container'>
				<div class='flex-item'>
					<div class='wrapper'>


						<!-- <span>{{ lpoAddress }}</span> -->
							<DataBlock title='Характеристика участка'>
								<ResultTable1/>
							</DataBlock>

							<DataBlock title='Таксационная характеристика'>
								<ResultTable2/>
							</DataBlock>
						<template v-if="['5','7'].includes(selectedLpo.inspection_type_id)">
							<DataBlock title="Распределение деревьев">
								<ResultTable3/>
							</DataBlock>

							<DataBlock title='Повреждения и мероприятия'>
								<ResultTable4/>
							</DataBlock>

							<DataBlock title='Параметры назначения мероприятия'>
								<ResultTableMzl/>
							</DataBlock>
						</template>
						<template v-if="['1','2', '3', '4'].includes(selectedLpo.inspection_type_id)">
							<template v-if="!modelTreesAreOpen && modelTreesExist">
								<DataBlock :title='selectedLpo.inspection_type_id === "2" ? "Распределение суммы площадей сечения" : "Распределение деревьев"'>
									<ResultTable3/>
								</DataBlock>

								<DataBlock title='Повреждения и мероприятия'>
									<ResultTable4/>
								</DataBlock>

								<DataBlock title='Параметры назначения мероприятия'>
									<ResultTableMzl/>
								</DataBlock>
							</template>
							<PMessage v-else severity="error" :closable="false">Необходимо закрыть редактирование модельных деревьев</PMessage>
						</template>
						
						<div class="links-block">
              				<router-link :to="linkPrev"><- Назад - Данные обследования</router-link>
            			</div>
					</div>
				</div>
			</div>

		</template>

	</div>
</template>

<script>
	import { mapState, mapGetters, mapActions } from 'vuex';

	import DataBlock from '../CurrentLpo__dataBlock';
	import ResultTable1 from './CurrentLpo__resultTable1';
	import ResultTable2 from './CurrentLpo__resultTable2';
	import ResultTable3 from './CurrentLpo__resultTable3';
	import ResultTable4 from './CurrentLpo__resultTable4';
	import ResultTableMzl from './CurrentLpo__resultTableMzl';

	export default {
		name: 'LpoResultData',
		components: {
			DataBlock,

			ResultTable1,
			ResultTable2,
			ResultTable3,
			ResultTable4,
			ResultTableMzl
		},
		data() {
			return {

				sectionLpEditMode: false,
				editedSectionLp: null,
			};
		},
		computed: {
			...mapState('selectedLpo', {
				selectedLpo: state => state.lpo
			}),
			 ...mapGetters('selectedLpo/recount', [
				'modelTreesAreOpen',
				'modelTreesExist',
			]),
			...mapGetters('selectedLpo', [
				'lpoAddress',
			]),
			linkPrev() {
      			return { name: "current-lpo-inspection" };
    		},
		},

	};
</script>


<style scoped src='@/style/wrapper.css'></style>

<style scoped>

	.data-block {
		margin-bottom: 5rem;
	}

</style>